'use client';
import { jsx as e, jsxs as l, Fragment as c } from "react/jsx-runtime";
import { Icon as r } from "@tameeni/icons";
import { cn as t } from "@tameeni/shared-logic";
import { Sheet as g, SheetTrigger as f, SheetOverlay as x, SheetContent as u, SheetHeader as b, SheetTitle as N, Accordion as w, AccordionItem as v, AccordionTrigger as y, AccordionContent as p, Separator as o, Button as d } from "@tameeni/ui";
import h from "react";
import { UserNav as L } from "./components/user-dropdown.js";
function j(a) {
  return /* @__PURE__ */ e(
    "header",
    {
      className: t(
        "w-full flex flex-col bg-white border-b border-slate-100",
        a.className
      ),
      children: a.children
    }
  );
}
function H(a) {
  const [i, m] = h.useState(!1);
  return /* @__PURE__ */ l(g, { onOpenChange: m, open: i, children: [
    /* @__PURE__ */ e(f, { asChild: !0, children: /* @__PURE__ */ e(
      "button",
      {
        className: t(
          "p-1.5 rounded-xs w-9 h-9 flex items-center justify-center",
          i ? "bg-blue-200" : "bg-slate-100"
        ),
        "aria-label": "Toggle navigation",
        children: /* @__PURE__ */ e(
          r,
          {
            width: "24",
            height: "24",
            name: "Hamburger",
            className: t(
              "transition-transform duration-300 cursor-pointer ease-in-out",
              i ? "w-5 h-5 scale-90" : "w-6 h-6 scale-100"
            )
          }
        )
      }
    ) }),
    /* @__PURE__ */ e(
      x,
      {
        className: t(
          "bg-black/50 max-sm:h-[calc(100vh-4rem)] sm:h-screen top-16 sm:top-0"
        )
      }
    ),
    /* @__PURE__ */ l(
      u,
      {
        side: a.direction,
        className: "flex flex-col bg-slate-50 !gap-0 w-screen min-w-80 max-w-sm px-0 py-0 shadow-none border-r-0 sm:w-fit overflow-y-hidden top-16 sm:top-0 max-sm:h-[calc(100vh-4rem)] sm:h-screen",
        children: [
          /* @__PURE__ */ l(b, { className: "w-full flex justify-between items-center px-4 pt-4", children: [
            /* @__PURE__ */ e(N, { children: /* @__PURE__ */ e(
              r,
              {
                height: "36",
                name: a.logo,
                className: t("h-[36px]", a.logoClassName)
              }
            ) }),
            /* @__PURE__ */ e(
              r,
              {
                name: "Close",
                onClick: () => m(!1),
                className: "w-6 h-6 cursor-pointer"
              }
            )
          ] }),
          /* @__PURE__ */ e("div", { className: "py-4 flex min-h-0 flex-1 flex-col gap-2 overflow-auto no-scrollbar", children: /* @__PURE__ */ e("nav", { className: "w-full", children: a.sideNav.map((s, k) => /* @__PURE__ */ l("div", { className: "mb-4", children: [
            /* @__PURE__ */ e("h3", { className: "px-4 text-sm font-bold hover:no-underline text-gray-800", children: s.label }),
            /* @__PURE__ */ e("div", { children: s.items.map((n) => n.subItems ? /* @__PURE__ */ e(w, { type: "single", collapsible: !0, className: "w-full", children: /* @__PURE__ */ l(
              v,
              {
                value: "sub",
                className: "px-4 border-b-0 data-[state=open]:bg-slate-100 transition-colors",
                children: [
                  /* @__PURE__ */ l(
                    y,
                    {
                      className: t(
                        "flex items-center justify-start text-sm font-normal gap-2 hover:text-blue-600 py-2 transition-colors",
                        n.isActive ? "text-blue-600" : "text-gray-700"
                      ),
                      children: [
                        /* @__PURE__ */ e("span", { "aria-hidden": "true", children: /* @__PURE__ */ e(
                          r,
                          {
                            width: "24",
                            height: "25",
                            className: t(
                              "w-4 h-4 md:w-6 md:h-6",
                              n.iconClassName
                            ),
                            name: n.icon
                          }
                        ) }),
                        /* @__PURE__ */ e("span", { className: "text-start grow", children: n.label })
                      ]
                    }
                  ),
                  /* @__PURE__ */ e(p, { children: n.subItems })
                ]
              }
            ) }) : /* @__PURE__ */ l(
              "a",
              {
                href: n.link,
                className: t(
                  "flex items-center text-sm font-normal gap-2 hover:text-blue-600 px-4 py-2 transition-colors",
                  n.isActive ? "text-blue-600" : "text-gray-700"
                ),
                "aria-label": n.label,
                children: [
                  /* @__PURE__ */ e("span", { "aria-hidden": "true", children: /* @__PURE__ */ e(
                    r,
                    {
                      width: "24",
                      height: "25",
                      className: t(
                        "w-4 h-4 md:w-6 md:h-6",
                        n.iconClassName
                      ),
                      name: n.icon
                    }
                  ) }),
                  n.label
                ]
              },
              n.label
            )) })
          ] })) }) }),
          /* @__PURE__ */ l("div", { className: "flex flex-col gap-4 px-4 py-4 border-t border-slate-200 bg-slate-50", children: [
            /* @__PURE__ */ l("div", { className: "flex items-center gap-4 w-full", children: [
              /* @__PURE__ */ e("p", { className: "text-gray-700 font-medium text-xs mb-0", children: a.followUsLabel }),
              /* @__PURE__ */ e("div", { className: "flex gap-2", children: a.socialLinks.map((s) => /* @__PURE__ */ e(
                "a",
                {
                  href: s.url,
                  "aria-label": s.label,
                  className: "text-gray-500 hover:text-gray-800",
                  target: "_blank",
                  rel: "noreferrer noopener",
                  children: /* @__PURE__ */ e(r, { name: s.icon, className: "size-5" })
                },
                s.url
              )) })
            ] }),
            /* @__PURE__ */ l("div", { className: "flex flex-col gap-2", children: [
              /* @__PURE__ */ e("p", { className: "text-gray-700 font-medium text-xs mb-0", children: a.downloadAppLabel }),
              /* @__PURE__ */ l("div", { className: "flex gap-2", children: [
                a.iosAppUrl && /* @__PURE__ */ e(
                  "a",
                  {
                    href: a.iosAppUrl,
                    target: "_blank",
                    className: "grow",
                    rel: "noreferrer noopener",
                    children: /* @__PURE__ */ e(r, { name: "Appstore", className: "h-7 w-full" })
                  }
                ),
                a.androidAppUrl && /* @__PURE__ */ e(
                  "a",
                  {
                    href: a.androidAppUrl,
                    target: "_blank",
                    className: "grow",
                    rel: "noreferrer noopener",
                    children: /* @__PURE__ */ e(r, { name: "GooglePlay", className: "h-7 w-full" })
                  }
                ),
                a.appGalleryUrl && /* @__PURE__ */ e(
                  "a",
                  {
                    href: a.appGalleryUrl,
                    target: "_blank",
                    className: "grow",
                    rel: "noreferrer noopener",
                    children: /* @__PURE__ */ e(r, { name: "AppGallery", className: "h-7 w-full" })
                  }
                )
              ] })
            ] })
          ] })
        ]
      }
    )
  ] });
}
function G(a) {
  const i = /* @__PURE__ */ l(c, { children: [
    /* @__PURE__ */ e(
      r,
      {
        height: "36",
        name: a.mainLogo,
        className: t("hidden md:block w-auto h-[36px]", a.logoClassName)
      }
    ),
    /* @__PURE__ */ e(
      r,
      {
        width: "30",
        height: "30",
        name: "TameeniLogoIcon",
        className: "md:hidden w-[30px] h-[30px] text-primary"
      }
    )
  ] });
  return /* @__PURE__ */ l("div", { className: "flex items-center gap-4", children: [
    a.as ? h.cloneElement(a.as, { children: i }) : /* @__PURE__ */ e("a", { href: a.link, children: i }),
    a.secondaryLogo && /* @__PURE__ */ l(c, { children: [
      /* @__PURE__ */ e(o, { orientation: "vertical", className: "h-3 bg-slate-300" }),
      /* @__PURE__ */ e(
        r,
        {
          height: "36",
          name: a.secondaryLogo,
          className: t("h-[36px]", a.secondaryLogoClassName)
        }
      )
    ] }),
    a.label && /* @__PURE__ */ l(c, { children: [
      /* @__PURE__ */ e(
        o,
        {
          orientation: "vertical",
          className: "hidden md:block h-3 bg-slate-300"
        }
      ),
      /* @__PURE__ */ e("span", { className: "text-sm text-slate-500 font-normal hidden md:block", children: a.label })
    ] })
  ] });
}
function O(a) {
  return /* @__PURE__ */ l(d, { variant: "text", size: "loose", onClick: a.onLanguageChange, children: [
    /* @__PURE__ */ e(
      r,
      {
        name: "Language",
        width: 24,
        height: 24,
        className: "w-6 h-6 sm:hidden text-slate-600",
        "aria-label": "Language"
      }
    ),
    /* @__PURE__ */ e("div", { className: "items-center hidden sm:block", children: /* @__PURE__ */ e("span", { className: t("text-sm text-slate-600 font-semibold"), children: a.label }) })
  ] });
}
function _(a) {
  return /* @__PURE__ */ l("div", { className: "flex items-center gap-4", children: [
    /* @__PURE__ */ e(
      o,
      {
        orientation: "vertical",
        className: "hidden md:block h-3 bg-slate-300"
      }
    ),
    a.isLoggedIn ? /* @__PURE__ */ e(
      L,
      {
        user: a.user,
        onLogout: a.onLogout,
        profileMenuItems: a.profileMenuItems,
        logoutLabel: a.logoutLabel,
        isNameTruncated: a.isNameTruncated
      }
    ) : /* @__PURE__ */ e(
      d,
      {
        variant: "solid",
        size: "sm",
        className: "w-fit px-4 font-normal",
        onClick: a.onLogin,
        children: a.loginLabel
      }
    )
  ] });
}
export {
  j as Header,
  G as HeaderLogo,
  H as HeaderSideNav,
  O as LanguageToggle,
  _ as UserProfile
};
//# sourceMappingURL=header.js.map
